export default __webpack_public_path__ + "static/media/check-circle.112433ed.svg";